import React, { Component } from 'react';

import classNames from 'classnames'
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import * as ModelAction from '../../../../../store/actions/ModelAction'
import { connect } from 'react-redux';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { createMuiTheme } from '@material-ui/core'
import * as DateTool from '../../../../../util/DateTool';
import * as StrTool from '../../../../../util/StrTool';
import Pagination from '@material-ui/lab/Pagination';
import CrudModalForUserCreateCantieri from './CrudModalForUserCreateCantieri'
import CrudModalForUserUpdateCantieri from './CrudModalForUserUpdateCantieri'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';




const styles = theme => ({

    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    table: {
        // minWidth: 650,
    },
    tableHead: {
        background: "#b9b9b9"
    },

    row: {
        '&:hover': {
            background: "#CACACA"
        }
    },
    cell: {
        '&:hover': {
            background: "#b9b9b9"
        },
    },
    modal: {
        display: 'block',
        position: 'absolute',
        overflow: 'scroll',
    },
    modalpaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: 900,
    },
    buttonback: {
        backgroundColor: "#b9b9b9",
        border: '0px solid #000',
        boxShadow: theme.shadows[0],
        padding: theme.spacing(1.5, 1.5, 1.5),

    },
    formControlS: {
        margin: theme.spacing(1),
        width: 120,
    },
    formControlM: {
        margin: theme.spacing(1),
        width: 300
    },
    formControlL: {
        margin: theme.spacing(1),
        width: 800
    },
    grammar: {
        width: 800
    },
    grammarPreview: {
        width: 800
    },
    cell_short: {
        fontSize: "10px",
        width: 50,
    },
    cell_medium: {
        fontSize: "10px",
        width: 100,
    },
    cell_clickable: {
        cursor: "pointer"
    },
    cell_searched: {
        background: "#FA8072"
    },
    height100: {
        height: '100%'
    },
    gridItem: {
    },
    button: {
        background: 'white',
        borderRadius: 3,
        border: 0,
        color: 'black',
        padding: '0 20px',
        '&:hover': {
            background: "#b9b9b9"
        },
    },
    container: {
        maxHeight: 600,
    },
});

const customTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#bfbfbf',
            light: '#969696',
            dark: '#616060',
        },
        secondary: {
            main: '#616060',
        },
    },
})




class CrudForUserClienti extends Component {

    constructor(props) {
        super(props);



        this.state = null;
        this.state = {
            page: 1,
            numData: this.props.modelProps.DefaultNum ? this.props.modelProps.DefaultNum : 200,
            searchedNum: 0,
            searchText: ''

        };

    }

    componentDidMount() {
        this.props.getModelCount(this.props.modelProps, this.props.logininfo.id)
        this.props.getModelList(this.props.modelProps, this.state.page, this.state.numData, this.props.logininfo.id);
        //this.props.setupWebSocket(this.props.logininfo.id);
    }



    onChangeInputNumData = (num) => {


        var total = this.props.modelList[this.props.modelName + "_count"]

        if (num >= total) {
            num = total;
        } else {
            //全件１ページ表示字のみ検索可
            this.setState({ searchText: '' })

        }

        this.setState({ numData: num });

        if (num == null || num == "") {
            this.props.getModelList(this.props.modelProps, this.state.page, total, this.props.logininfo.id);
        } else {
            this.props.getModelList(this.props.modelProps, this.state.page, num, this.props.logininfo.id);
        }

    }

    onChangePagination = (page) => {
        this.setState({ page: page });
        this.props.getModelList(this.props.modelProps, page, this.state.numData, this.props.logininfo.id);
    }





    render() {

        const { classes } = this.props;

        return (
            <Grid
                container
                direction="row"
                justify="space-around"
                alignItems="center"
            >

                <Grid item xs={12}  >
                    <Grid
                        container
                        direction="row"
                        justify="space-around"
                        alignItems="center"
                    >
                        <Grid item xs={12}  >
                            <Grid
                                container
                                direction="row"
                                justify="flex-start"
                                alignItems="center"
                            >

                                <CrudModalForUserCreateCantieri
                                    modelProps={this.props.modelProps}
                                    modelName={this.props.modelName}
                                />
                                <div>
                                    <InputLabel htmlFor="input-text">cerca cantieri...</InputLabel>
                                    <Input
                                        id="input-text"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        }
                                        onChange={(e) => {
                                            this.setState({ searchText: e.target.value })
                                            var total = this.props.modelList[this.props.modelName + "_count"]
                                            this.onChangeInputNumData(total)



                                        }}
                                        value={this.state.searchText}
                                        className={classNames(classes.formControlM)}
                                    />
                                </div>


                                <Pagination
                                    onChange={(e, page) => { e.preventDefault(); this.onChangePagination(page) }}
                                    page={this.state.page}
                                    count={this.props.modelList
                                        ? Math.ceil(this.props.modelList[this.props.modelName + "_count"] / this.state.numData)
                                        : 3}
                                />
                                <TextField
                                    id="standard-basic"
                                    label="number of datas"
                                    value={this.state.numData}
                                    onChange={(e) => { e.preventDefault(); this.onChangeInputNumData(e.target.value) }}
                                />
                                <Typography variant="h6" >total:{this.props.modelList[this.props.modelName + "_count"]}</Typography>


                            </Grid>
                        </Grid>
                        <Grid item xs={12} >
                            <div >
                                <TableContainer className={classes.container} >
                                    <Table stickyHeader aria-label="a dense table"  >
                                        <TableHead className={classes.tableHead} >
                                            <TableRow >

                                                <TableCell key={'hd_Descrizione'} align="left" style={{ backgroundColor: '#BDBDBD' }} >Descrizione</TableCell>
                                                <TableCell key={'hd_Clienti'} align="left" style={{ backgroundColor: '#BDBDBD' }} >Clienti</TableCell>
                                                <TableCell key={'hd_Indirizzo'} align="left" style={{ backgroundColor: '#BDBDBD' }} >Indirizzo</TableCell>
                                                <TableCell key={'hd_Prov'} align="left" style={{ backgroundColor: '#BDBDBD' }} >Prov</TableCell>
                                                <TableCell key={'hd_Localita'} align="left" style={{ backgroundColor: '#BDBDBD' }} >Localita</TableCell>
                                                <TableCell key={'hd_Cap'} align="left" style={{ backgroundColor: '#BDBDBD' }} >Cap</TableCell>
                                                <TableCell key={'hd_DataInizioLavori'} align="left" style={{ backgroundColor: '#BDBDBD' }} >DataInizioLavori</TableCell>
                                                <TableCell key={'hd_DataFineLavori'} align="left" style={{ backgroundColor: '#BDBDBD' }} >DataFineLavori</TableCell>
                                                <TableCell key={'hd_Note'} align="left" style={{ backgroundColor: '#BDBDBD' }} >Note</TableCell>


                                                <TableCell align="left" style={{ backgroundColor: '#BDBDBD' }} ></TableCell>
                                                <TableCell align="left" style={{ backgroundColor: '#BDBDBD' }}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody >
                                            {this.props.modelList[this.props.modelName].map((m) => {

                                                var showData = false;

                                                if (this.state.searchText.trim() == '') {
                                                    showData = true;
                                                } else {

                                                    if (m['Descrizione'].toLowerCase().indexOf(this.state.searchText.trim().toLowerCase()) != -1) {
                                                        showData = true;
                                                    }

                                                }


                                                if (showData) {

                                                    return (
                                                        <TableRow key={m.id} className={classes.row}>




                                                            <TableCell align="left" className={classNames(classes.cell)} >{m['Descrizione']}</TableCell>

                                                            <TableCell align="left" className={classNames(classes.cell)} >{m['Clienti']['Nome'] ? m['Clienti']['Nome'] : null + ' ' + m['Clienti']['Cognome'] ? m['Clienti']['Cognome'] : null}</TableCell>
                                                            <TableCell align="left" className={classNames(classes.cell)} >{m['Indirizzo']}</TableCell>
                                                            <TableCell align="left" className={classNames(classes.cell)} >{m['Prov']}</TableCell>
                                                            <TableCell align="left" className={classNames(classes.cell)} >{m['Localita']}</TableCell>
                                                            <TableCell align="left" className={classNames(classes.cell)} >{m['Cap']}</TableCell>
                                                            <TableCell align="left" className={classNames(classes.cell)} >{StrTool.createStrDD_MM_YYYY(m['DataInizioLavori'])}</TableCell>
                                                            <TableCell align="left" className={classNames(classes.cell)} >{StrTool.createStrDD_MM_YYYY(m['DataFineLavori'])}</TableCell>
                                                            <TableCell align="left" className={classNames(classes.cell)} >{m['Note']}</TableCell>
                                                            <TableCell
                                                                align="left"
                                                                className={classNames(classes.cell, classes.cell_short,)}
                                                            >
                                                                <CrudModalForUserUpdateCantieri
                                                                    modelProps={this.props.modelProps}
                                                                    modelName={this.props.modelName}
                                                                    modelValue={m} />
                                                            </TableCell>
                                                            <TableCell
                                                                align="right"
                                                                className={classNames(classes.cell, classes.cell_short)}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    if (window.confirm("deleting data id : " + m['Descrizione'])) {
                                                                        this.props.submitDelete(
                                                                            this.props.socket,
                                                                            this.props.modelProps,
                                                                            this.state.page,
                                                                            this.state.numData,
                                                                            m.id,
                                                                            this.props.modelProps,
                                                                            this.props.logininfo.id
                                                                        )
                                                                    }
                                                                }}>
                                                                <DeleteForeverIcon className={classNames(classes.cell_clickable)} />
                                                            </TableCell>
                                                        </TableRow>

                                                    )



                                                } else {

                                                    return null;
                                                }


                                            })}


                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Grid >
                    </Grid >
                </Grid>

            </Grid >





        );
    }
}


const mapStateToProps = (state) => {
    return {
        modelList: state.model,
        socket: state.webSocket.socket,
        logininfo: state.auth.logininfo

    }
}

const mapDispatchToProps = (dispatch) => {

    return {

        getModelList: (getModelProps, page, numData, arrInclude, order, access_token) => {
            dispatch(ModelAction.apiGet(getModelProps, page, numData, arrInclude, order, access_token))
        },
        getModelCount: (getModelProps, access_token) => {
            dispatch(ModelAction.apiGetCount(getModelProps, access_token))
        },
        submitDelete: (socket, getModelProps, page, numData, id, deleteModelProps, access_token) => {
            dispatch(ModelAction.apiDelete(socket, getModelProps, page, numData, id, deleteModelProps, access_token))
        },

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(CrudForUserClienti));